export const version = "abstract-signer/5.7.0";
//# sourceMappingURL=_version.js.map